
<form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
  <nz-alert nzType="info"
            nzMessage="Укажите Ваш e-mail и пароль, для входа."
            nzShowIcon></nz-alert>
  <div class="form-group mt-3">
    <input
      (change)="cd.detectChanges()"
      (input)="cd.detectChanges()"
      type="email" [email]="true"
      formControlName="email"
      class="form-control form-control-lg justify-content-between"
      placeholder="example@mail.ru"
      id="username"
    />
  </div>
  <div class="form-group mt-3">
    <input
      (change)="cd.detectChanges()"
      (input)="cd.detectChanges()"
      type="password"
      placeholder="Пароль"
      formControlName="password"
      class="form-control form-control-lg justify-content-between"
      id="password"
    />
  </div>
  <button [disabled]="Form.invalid" [nzBlock]="true" nzSize="large" nzType="primary"
          class="effectMouse effect-white ant-btn-block"
          [nzLoading]="isLoading$ | async"
          nz-button>
    {{(isLoading$ | async) ? 'Авторизация...' : 'Войти'}}
    <i-feather [style.margin-top.px]="-5" name="log-in"
               class="ml-auto icon-md align-middle"></i-feather>
  </button>
  <!-- Submit -->
  <div class="d-flex justify-content-between mt-3 mb-5">
    <div>
      <i-feather name="chevron-left" class="mr-2 icon-md text-primary"></i-feather>
      <a class="text-underline pointer text-muted"
         (click)="authService.mode$.next('Регистрация')">Зарегистрироваться</a>
    </div>
    <div>
      <i-feather name="lock" class="mr-2 icon-md text-primary"></i-feather>
      <a class="text-underline pointer text-muted" (click)="authService.mode$.next('Восстановление')">Забыли
        пароль?</a>
    </div>
  </div>

</form>


<nz-alert class="mb-2" *ngIf="lastError" nzType="error"
          [nzMessage]="lastErrorMessage"
          nzShowIcon></nz-alert>
<ng-template #lastErrorMessage>
  {{interfaceService.errorHandling(lastError, false) || 'Неопознаная ошибка, напишите нам или попробуйте чуть позже.'}}
</ng-template>
